import { Button, Container, TextField, Typography, Divider } from "@mui/material";
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Context } from "../../App";
import GoogleLoginButton from "../ui/GoogleLoginButton";

export default function LoginForm({ onLogin }) {
    const [mail, setMail] = React.useState('');
    const [password, setPassword] = React.useState('');
    const { setIsConnected, setUserId } = useContext(Context);
    const navigate = useNavigate();

    const handleGoogleSuccess = (userData) => {
        console.log('Google authentication successful:', userData);
        
        // Stocker les informations utilisateur
        localStorage.setItem('token', userData.token); // Nom cohérent avec App.js
        localStorage.setItem('userData', JSON.stringify(userData.user));
        localStorage.setItem('user', userData.user._id); // ID utilisateur
        
        // Mettre à jour le contexte
        setIsConnected(true);
        setUserId(userData.user._id);
        
        // Rediriger vers l'accueil ou le formulaire d'info complémentaire si nécessaire
        const user = userData.user;
        console.log('User data for completeness check:', user); // Debug
        const requiredFields = ['genre', 'nom', 'prenom', 'mail', 'zip_code', 'ville'];
        const hasAllInfo = requiredFields.every(field => {
            const value = user[field];
            if (value === null || value === undefined) return false;
            // Pour les strings, vérifier qu'elles ne sont pas vides après trim
            if (typeof value === 'string') return value.trim() !== '';
            // Pour les autres types (comme les nombres), vérifier qu'ils existent
            return value !== '' && value !== 0;
        });
        console.log('User has all required info:', hasAllInfo); // Debug
        const redirectPath = hasAllInfo ? '/' : '/info_complementaire';
        console.log('Navigating to:', redirectPath); // Debug
        navigate(redirectPath);
    };

    const handleGoogleError = (error) => {
        console.error('Google authentication failed:', error);
        // Gérer l'erreur (affichage notification, etc.)
    };

    const handleClassicLogin = async () => {
        // Logique de connexion classique existante
        console.log('Classic login:', { mail, password });
        // À implémenter selon votre logique existante
    };

    return <Container maxWidth="sm" sx={{ display:'flex', flexDirection:'column', mt: 4, rowGap:2, minWidth: '400px' }}>
        <Typography variant="h4" align="center" sx={{ mb: 2 }}>Je me connecte</Typography>

        {/* Connexion classique */}
        <TextField fullWidth label="Adresse e-mail" variant="outlined" value={mail} 
        onChange={(e) => setMail(e.target.value)} />

        <TextField fullWidth type="password" label="Mot de passe" variant="outlined" value={password} 
        onChange={(e) => setPassword(e.target.value)} />

        <Button 
          variant="contained" 
          color="primary" 
          sx={{alignSelf: 'center', px: 5, mb: 2}}
          onClick={handleClassicLogin}
        >
          Connexion
        </Button>

        <Divider sx={{ my: 2 }}>
          <Typography variant="body2" color="text.secondary">
            Ou connectez-vous avec
          </Typography>
        </Divider>

        {/* Connexion Google */}
        <GoogleLoginButton 
          onSuccess={handleGoogleSuccess}
          onError={handleGoogleError}
        />

    </Container>
}